<template>
<div>
    <div class='filters-container' :class="{'inside-popout': inside_popout}">
        <div class='filters-inner-container'>
            <div class='top-section'>
                <div v-show='inside_popout' class='filters-header'>Filters</div>
                <div class='top-section-right'>
                    <div class='reset-button' @click='resetFilters'>Reset Filters</div>
                    <div v-show='inside_popout' class='close-button' @click='closeFilters'><i class="fa-thin fa-xmark"></i></div>
                </div>
            </div>

            <div class='separator'></div>
            <div class="filter-stock-options">
                <CheckBox id='checkbox-in-stock' label="In stock items only" :checked="filter_in_stock_items" @checkBoxListener='setStockItems'/>
            </div>
        
            <div v-for='filter_item in filter_options' :key='filter_item.product_attribute_id'>
                <div class='filter-option-header-container' @click='toggleFilterSection(filter_item.product_attribute_id)'>
                    <div class='filter-option-title'>{{filter_item.title}}</div>
                    <div v-show='!expanded_sections[filter_item.product_attribute_id]'><i class="fa-solid fa-square-plus header-icon"></i></div>
                    <div v-show='expanded_sections[filter_item.product_attribute_id]'><i class="fa-solid fa-square-minus header-icon"></i></div>
                </div>
                    <div class='separator'></div>
                <div class='filter-options-section filter-content' :class="{'expanded' : expanded_sections[filter_item.product_attribute_id]}">
                    <div v-for='filter_option in filter_item.options' :key='filter_option.id'>
                        <div>
                            <CheckBox :id='filter_item.product_attribute_id + "_" + filter_option.id' :label='filter_option.option' @checkBoxListener='filterClicked' :counter='filter_option.count' :checked='filter_option.checked' :disabled='filter_checkboxes_disabled' />
                        </div>
                    </div>
                </div>
            </div>
            <div class='separator'></div>
            <div v-if="(typeof filter_data.prices != 'undefined')" class="filter-price-range">
                <PriceRangeFilter :price_filter_watcher="price_filter_watcher" :min_price="filter_data.prices.min_price" :max_price="filter_data.prices.max_price" @filterPrice='filterPrice' />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Button from '@/ecom/components/buttons/Button.vue';
import Field from '@/ecom/components/fields/Field.vue';
import CheckBox from '@/ecom/components/fields/CheckBox.vue';
import PriceRangeFilter from '@/ecom/components/products/list/PriceRangeFilter.vue';

export default {
    components: {Button, Field, CheckBox, PriceRangeFilter},
    props: ['filter_options', 'filter_data', 'show_filters_watcher', 'filter_checkboxes_disabled', 'default_filter_options_watcher', 'inside_popout'],
    emits: ['expandFilterSectionListener', 'closePopOutListener', 'updatedFilterListener'],
    data(){
        return{
            filter_attributes_array: [],
            expanded_sections: [],
            filter_in_stock_items: true,
            price_filter_watcher: null,
        }
    },
    methods:{
        updateFilter(){
            this.$emit('updatedFilterListener', this.filter_attributes_array);
        },
        resetFilters(){
            for (let i = 0; i < this.filter_options.length; i++) {
                for (let j = 0; j < this.filter_options[i].options.length; j++) {
                    this.filter_options[i].options[j].checked = false;
                }
            }

            this.filter_attributes_array = [];
            this.filter_in_stock_items = true;
            this.addFilterStockToArray();
            this.filterPrice(this.filter_data.prices.min_price, this.filter_data.prices.max_price);
            this.price_filter_watcher = +new Date();
            this.updateFilter();
        },
        closeFilters(){
            this.$emit('closePopOutListener');
        },
        filterClicked(id, checked){
            let split_id = id.split('_');
            let product_attribute_id = split_id[0];
            let option_id = split_id[1];
            let selected_filter = this.filter_options.filter(x=>x.product_attribute_id == product_attribute_id)[0];
            let selected_option = selected_filter.options.filter(x=>x.id == option_id)[0];

            if(checked){
                this.addFilterOptionToArray(product_attribute_id, selected_filter, selected_option);
            }
            else{
                this.removeFilterOption(product_attribute_id, selected_option);
            }

            this.updateFilter();

        },
        addFilterOptionToArray(product_attribute_id, selected_filter, selected_option){

            let attribute_already_in_filter = this.filter_attributes_array.filter(x=>x.product_attribute_id == product_attribute_id);

            if(attribute_already_in_filter.length > 0){
                attribute_already_in_filter[0].options.push(selected_option.option);
            }
            else{
                this.filter_attributes_array.push({
                    product_attribute_id: product_attribute_id,
                    attribute: selected_filter.title,
                    options: [selected_option.option]
                });
            }
        },
        removeFilterOption(product_attribute_id, selected_option){
            let current_filter = this.filter_attributes_array.filter(x=>x.product_attribute_id == product_attribute_id)[0];

            current_filter.options.splice(current_filter.options.indexOf(selected_option.option), 1);

            if(current_filter.options.length == 0){
                this.filter_attributes_array= this.filter_attributes_array.filter(x=>x.product_attribute_id != product_attribute_id);
            } 
        },
        toggleFilterSection(product_attribute_id){
            this.expanded_sections[product_attribute_id] = !this.expanded_sections[product_attribute_id];
        },
        setStockItems(id, checked) {    
            if(id == 'checkbox-in-stock' && checked) {
                this.filter_in_stock_items = checked;
                this.addFilterStockToArray();
            } else {
                const index = this.filter_attributes_array.findIndex(x => x.attribute == 'instock');
                if(index !== -1) {
                    this.filter_attributes_array.splice(index, 1);
                }
            }
            this.updateFilter();        
        },
        addFilterStockToArray() {
            if(this.filter_in_stock_items) {
                    this.filter_attributes_array.push({
                    product_attribute_id: 0,
                    attribute: 'instock',
                    options: [this.filter_in_stock_items]
                });
            }
        },
        filterPrice(min_price, max_price) {
            let current_filter = this.filter_attributes_array.filter(x=>x.attribute == 'price')[0];
            if(current_filter) {
                this.updateFilterPriceToArray(min_price, max_price, current_filter);
            } else {
                this.addFilterPriceToArray(min_price, max_price);
            }
            
            this.updateFilter();     
        },
        addFilterPriceToArray(min_price, max_price) {
            this.filter_attributes_array.push({
                product_attribute_id: 0,
                attribute: 'price',
                options: [{'min_price' : min_price, 'max_price' : max_price}]
            });
        },
        updateFilterPriceToArray(min_price, max_price, current_filter) {
            current_filter.options[0].min_price = min_price;
            current_filter.options[0].max_price = max_price;
            this.filter_attributes_array[this.filter_attributes_array.findIndex(x=>x.attribute == 'price')] = current_filter;
        },
        setDefaults(){
            for (let i = 0; i < this.filter_options.length; i++) {
                let current_filter = this.filter_options[i];
                
                for (let j = 0; j < current_filter.options.length; j++) {
                    let current_option = current_filter.options[j];
                    if(current_option.checked){
                        this.addFilterOptionToArray(current_filter.product_attribute_id, current_filter, current_option);
                    }
                }
            }
        },
        expandAllSections(){
            for (let i = 0; i < this.filter_options.length; i++) {
                this.expanded_sections[this.filter_options[i].product_attribute_id] = true;
            }
        }
    },
    mounted(){
       this.addFilterStockToArray();
       this.expandAllSections();
       this.setDefaults();
    },
    watch:{
        'show_filters_watcher': function(){
            for (let i = 0; i < this.filter_options.length; i++) {
                this.expanded_sections[this.filter_options[i].product_attribute_id] = false;
            }
        },
        'filter_options': function() {
            for (let i = 0; i < this.filter_attributes_array.length; i++) {
                if(this.filter_attributes_array[i].product_attribute_id > 0) {
                    const filter_option = this.filter_options.find(item => item.product_attribute_id === this.filter_attributes_array[i].product_attribute_id);
                    if(filter_option) {
                        let all_options = filter_option.options.map(x => x.option);
                        this.filter_attributes_array[i].options = this.filter_attributes_array[i].options.filter(option => all_options.includes(option));
                    }
                }
            }

            // for (let i = 0; i < this.filter_options.length; i++) {
            //     this.expanded_sections[this.filter_options[i].product_attribute_id] = true;
            // }

            if(this.default_filter_options_watcher == true){
                this.setDefaults();
                this.expandAllSections();
            }
        }
    }
}
</script>

<style scoped lang='scss'>

.filters-container{
    display: flex;
    flex-direction: column;
    gap: 20px;
    overflow-y: auto;
    overflow-y:auto; 
    overflow-x:hidden; 
    scrollbar-width: thin; //Firefox only
    scrollbar-color: darkgrey white; //Firefox only
    width: 250px;

    @media(max-width: 1000px){
        width: 200px;
    }

    @media(max-width: 768px){
        width: 90%;
    }
}

.filters-container.inside-popout{
    padding: 20px;
    max-width: 100%;
}

.filters-container::-webkit-scrollbar { //Chrome, Edge, and Safari 
  width: 0.5rem;
}
 
.filters-container::-webkit-scrollbar-track{ //Chrome, Edge, and Safari 
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
}
 
.filters-container::-webkit-scrollbar-thumb { //Chrome, Edge, and Safari 
  background-color: darkgrey;
  border-radius: 10px;
}

.filters-inner-container{
    padding-bottom: 50px;
}

.top-section{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.top-section-right{
    display: flex;
    gap: 20px;
    align-items: center;
}

.close-button{
    font-size: 1.5rem;
    cursor: pointer;
}

.button{
    width: 100px;
}

.price-container{
    display: flex;
    gap: 50px;
}

.filter-option-header-container{
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 12px;
    cursor: pointer;
}

.header-icon{
    color: var(--dark-grey);
}

.filters-header{
    font-size: 1.4rem;
}

.separator{
    height: 1px;
    width: 100%;
    background-color: #DDDBDC;
    margin-bottom: 8px;
}

.reset-button{
    cursor: pointer;
    font-size: 0.95rem;
    color: var(--black);
    text-decoration: underline;
}

.filter-option-title{
    font-size: 0.9rem;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--maj-slate);
}

.filter-options-section{
    // margin-bottom: 20px;
    max-height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin; //Firefox only
    scrollbar-color: darkgrey white; //Firefox only
    
}

.filter-options-section::-webkit-scrollbar { //Chrome, Edge, and Safari 
  width: 0.5rem;
}
 
.filter-options-section::-webkit-scrollbar-track{ //Chrome, Edge, and Safari 
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
}
 
.filter-options-section::-webkit-scrollbar-thumb { //Chrome, Edge, and Safari 
  background-color: darkgrey;
  border-radius: 10px;
}

.filter-content {
  overflow-y: hidden;
  max-height: 0;
  transition: all 0.6s ease;
  max-width: 500px;
}

.filter-content.expanded{
    max-height: 200px; 
    margin-bottom: 20px;
    overflow-y: auto;
}
.filter-stock-options{
    margin-top: 19px;
    margin-bottom: 15px;
}
</style>